module.exports = "<a target=\"{{target}}\" href=\"{{href}}\">{{title}}</a>";